/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Category_Filter_AriaInputs */



/**
* | output |
* | --- |
* | "Filter errors by category" |
*
* @param {Qc_Category_Filter_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_category_filter_aria = /** @type {((inputs?: Qc_Category_Filter_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Category_Filter_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtrer les erreurs par catégorie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler nach Kategorie filtern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtra gli errori per categoria")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтровать ошибки по категории")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtrar errores por categoría")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按类别筛选错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カテゴリでエラーを絞り込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("श्रेणी के अनुसार त्रुटियाँ फ़िल्टर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtrar erros por categoria")
	return /** @type {LocalizedString} */ ("Filter errors by category")
});